import { Injectable } from '@angular/core';
import 'rxjs/Rx';
import { ApiService } from '../guards/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LoginService {
  constructor(private apiService: ApiService) { }

  login(user) {
    return this.apiService.post('/login', user).map(data => data);
  }

  logout() {
    return this.apiService.post('/logout').map(data => data);
  }

  getAgreement() {
    return this.apiService.get('/dataprotectionagreement').map(data => data);
  }

  getInnerAgreement(AppId) {
    return this.apiService.get('/innerdataprotectionagreement/'+AppId).map(data => data);
  }

  updateAgreement(id) {
    return this.apiService.post('/userdataprotectionagreement/' + id).map(data => data);
  }

  updateInnerAgreement(id, appid) {
    return this.apiService.post('/userinnerdataprotectionagreement/' + id + '/'+ appid).map(data => data);
  }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/authentication/login/login.service.ts